/**
 * Warning copy for the "set importance to zero" confirmation dialog.
 *
 * Per the Readiness levels of responsibility assignments spec (MDP-598), setting a
 * Role Assignment or Responsibility Assignment importance to 0 hides that row from
 * the employee and from any coach reviewing that employee. Position Assignments are
 * unaffected and must never show this dialog.
 */

const ROLE = "role";
const RESPONSIBILITY = "responsibility";

export function isImportanceZeroWarningKind(kind) {
  const normalized = String(kind || "").toLowerCase();
  return normalized === ROLE || normalized === RESPONSIBILITY;
}

export function buildImportanceZeroWarning(kind) {
  const normalized = String(kind || "").toLowerCase();
  const subject = normalized === ROLE ? "role" : "responsibility";

  return {
    title: `Hide this ${subject}?`,
    message: `This ${subject} will no longer be visible to the employee or to any coach reviewing that employee.`,
    confirmLabel: "Yes, hide it",
    cancelLabel: "Cancel",
  };
}
